import { createAppAsyncThunk } from 'reduxTyped'
import {
  type AgencyCommissionsFilters,
  agencyCommissionsFilterUpdated,
} from 'apps/agency/model/events'
import { handleError } from 'shared/api/lib/errors/handlers'
import { AgencyApi } from 'shared/api/requests/agency'
import type {
  AgencyCommissionByPage,
  AgencyPageListWithCommission,
} from 'shared/api/requests/agency/schemas'

interface FetchPagesWithCommissionsArgs extends AgencyCommissionsFilters {
  agencyId: number
}

interface FetchCommissionsByPageArgs extends FetchPagesWithCommissionsArgs {
  pageId: number
}

const getRejectValue = (error: unknown) =>
  (error as { response?: unknown } | null)?.response ?? error

export const fetchPagesWithCommissions = createAppAsyncThunk<
  AgencyPageListWithCommission,
  FetchPagesWithCommissionsArgs
>(
  'agency/commissions/fetchPages',
  async ({ agencyId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.getPageListWithCommission({
        query: {
          agency_id: agencyId,
          date_start: startDate,
          date_end: endDate,
        },
      })

      return data
    } catch (error) {
      handleError(error)

      return rejectWithValue(getRejectValue(error) as Error)
    }
  },
)

export const fetchCommissionsByPage = createAppAsyncThunk<
  AgencyCommissionByPage,
  FetchCommissionsByPageArgs
>(
  'agency/commissions/fetchByPage',
  async ({ agencyId, pageId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.getCommissionByPage({
        query: {
          agency_id: agencyId,
          page_id: pageId,
          date_start: startDate,
          date_end: endDate,
        },
      })

      return data
    } catch (error) {
      handleError(error)

      return rejectWithValue(getRejectValue(error) as Error)
    }
  },
)

export const fetchFilteredCommissions =
  ({ agencyId, startDate, endDate }: FetchPagesWithCommissionsArgs) =>
  (dispatch: AppDispatch) => {
    dispatch(agencyCommissionsFilterUpdated({ startDate, endDate }))

    return dispatch(fetchPagesWithCommissions({ agencyId, startDate, endDate }))
  }
